import { useQuery } from "@apollo/client";
import { ProjectDetailsDocument } from "../../../../../../__generated__/graphql";

export default function useProjectDetails(projectId?: string | null) {
  const { data, loading, error, refetch } = useQuery(ProjectDetailsDocument, {
    variables: {
      projectId: projectId ?? "",
    },
    skip: !projectId,
  });

  return { data, loading, error, refetch };
}
